import { buildSubDomain } from "../../../plugins/utils";

const winlottery = {
  column: 3,
  isFrame: false,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "navigateToRoute",
  gameRoutePrefix: "/",
  frameUrl: "",
  imgPathPrefix: "/images/win/games/",
  game_list: [
    {
      code: "LOTLAUNCH",
      name: "极速火箭",
      image: "/images/game/selfGames/LOTLAUNCH.png",
    },
    {
      code: "LOTFEDERAL",
      name: "LOTFEDERAL",
      image: "/images/game/selfGames/LOTFEDERAL.png",
    },
    {
      code: "LOTGOPHERS",
      name: "GOPHERS",
      image: "/images/game/selfGames/LOTGOPHERS.png",
    },
  ],
};

const mg = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  //gameItemOnClick type: openGameInPopup
  //need to set api in homePage
  gameItemOnClick: "openGameInPopup",
  frameUrl: "https://gamemgslotstaging.meta188.cc",
  game_list: [
    {
      code: "SMG_queenofAlexandria",
      name: "Queen of Alexandria",
      image: "/images/game/mg/SMG_queenofAlexandria.png",
    },
    {
      code: "SMG_amazingLinkZeus",
      name: "Amazing Link Zeus",
      image: "/images/game/mg/SMG_amazingLinkZeus.png",
    },
    {
      code: "SMG_luckyClucks",
      name: "Lucky Clucks",
      image: "/images/game/mg/SMG_luckyClucks.png",
    },
  ],
};

const lottery77 = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: JSON.parse(process.env.REACT_APP_DOUBLE7_LOTTERY_SHOW_POPUP),
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameCustomLink",
  gameRoutePrefix: JSON.parse(process.env.REACT_APP_SPECIAL_DIRECT)
    ? buildSubDomain("game77lottery")
    : process.env.REACT_APP_DOUBLE_SEVEN_MOBILE_URL,
  frameUrl: "https://game77lotterystaging.meta188.cc?currency=MYR&lang=en",
  game_list: [
    {
      code: "LOTEC1",
      name: "LOTEC1",
      image: "/images/game/77lottery/LOTEC1DWD.png",
    },
    {
      code: "LOTEC3",
      name: "LOTEC3",
      image: "/images/game/77lottery/LOTEC3DWD.png",
    },
    {
      code: "LOTEC5",
      name: "LOTEC5",
      image: "/images/game/77lottery/LOTEC5DWD.png",
    },
  ],
};

const saba = {
  column: 1,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: false,
  haveTutorial: true,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  frameUrl: "",
  game_list: [
    {
      code: "saba",
      name: "saba",
      image: "/images/game/saba/saba.png",
    },
  ],
};

const fbworldcup = {
  column: 1,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  frameUrl: "",
  game_list: [],
};

const sabacricket = {
  column: 1,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  frameUrl: "",
  game_list: [
    {
      code: "saba",
      name: "saba",
      image: "/images/game/saba/saba.png",
    },
  ],
};

const jollysport = {
  column: 1,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  frameUrl: "",
  game_list: [],
};

const t1 = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [
    {
      code: "crash",
      name: "crash",
      image: "/images/game/t1/crash.png",
    },
    {
      code: "dice",
      name: "dice",
      image: "/images/game/t1/dice.png",
    },
    {
      code: "mine",
      name: "mine",
      image: "/images/game/t1/mine.png",
    },
    {
      code: "double",
      name: "double",
      image: "/images/game/t1/double.png",
    },
    {
      code: "hilo",
      name: "hilo",
      image: "/images/game/t1/hilo.png",
    },
    {
      code: "limbo",
      name: "limbo",
      image: "/images/game/t1/limbo.png",
    },
    {
      code: "plinko",
      name: "plinko",
      image: "/images/game/t1/plinko.png",
    },
    {
      code: "tower",
      name: "tower",
      image: "/images/game/t1/tower.png",
    },
    {
      code: "triple",
      name: "triple",
      image: "/images/game/t1/triple.png",
    },
    {
      code: "crypto",
      name: "crypto",
      image: "/images/game/t1/crypto.png",
    },
    {
      code: "keno",
      name: "keno",
      image: "/images/game/t1/keno.png",
    },
    {
      code: "coin",
      name: "coin",
      image: "/images/game/t1/coin.png",
    },
  ],
};

const evo = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: false,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  //gameItemOnClick type: openIFrameApiLink
  gameItemOnClick: "openIFrameApiLink",
  game_list: [
    {
      id: "CrazyTime0000001",
      code: "crazytime",
      name: "Crazy Time",
      image: "/images/game/evo/Crazy_Time.png",
    },
    {
      id: "MOWDream00000001",
      code: "moneywheel",
      name: "Dream Catcher",
      image: "/images/game/evo/Dream_Catcher.png",
    },
    {
      id: "vctlz20yfnmp1ylr",
      code: "roulette",
      name: "Roulette",
      image: "/images/game/evo/Roulette.png",
    },
    {
      id: "rng-topcard00001",
      code: "rng-topcard",
      name: "Top Card",
      image: "/images/game/evo/First_Person_Top_Card_DNT.png",
    },
    {
      id: "MegaBall00000001",
      code: "megaball",
      name: "Mega Ball",
      image: "/images/game/evo/Mega_Ball.png",
    },
    {
      id: "Monopoly00000001",
      code: "monopoly",
      name: "Monopoly Live",
      image: "/images/game/evo/Monopoly_Live.png",
    },
    {
      id: "CrazyCoinFlip001",
      code: "crazycoinflip",
      name: "Crazy Coin Flip",
      image: "/images/game/evo/Crazy_Coin_Flip.png",
    },
    {
      id: "MonBigBaller0001",
      code: "monopolybigballer",
      name: "MONOPOLY Big Baller DNT",
      image: "/images/game/evo/MONOPOLY_Big_Baller_DNT.png",
    },
    {
      id: "AmericanTable001",
      code: "americanroulette",
      name: "American Roulette",
      image: "/images/game/evo/American_Roulette.png",
    },
    {
      id: "o7347okwaeasvy2y",
      code: "blackjack",
      name: "Blackjack VIP 1",
      image: "/images/game/evo/Blackjack_VIP_1.png",
    },
    {
      id: "InstantRo0000001",
      code: "instantroulette",
      name: "Instant Roulette",
      image: "/images/game/evo/Instant_Roulette.png",
    },
    {
      id: "BacBo00000000001",
      code: "bacbo",
      name: "Bac Bo",
      image: "/images/game/evo/Bac_Bo.png",
    },
  ],
};

const pp = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [
    {
      code: "vs20olympgate",
      name: "Gates of Olympus",
      image: "https://api.prerelease-env.biz/game_pic/square/200/vs20olympgate.png",
    },
    {
      code: "vs20fruitsw",
      name: "Sweet Bonanza",
      image: "https://api.prerelease-env.biz/game_pic/square/200/vs20fruitsw.png",
    },
    {
      code: "vs20sugarrush",
      name: "Sugar Rush",
      image: "https://api.prerelease-env.biz/game_pic/square/200/vs20sugarrush.png",
    },
  ],
};

const pg = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [
    {
      game_id: 42,
      game_code: "ganesha-gold",
      name: "Ganesha Gold",
      image: "https://meta-game-share.s3.ap-east-1.amazonaws.com/pg/icon/ganesha-gold.png",
    },
    {
      game_id: 126,
      game_code: "fortune-tiger",
      name: "Fortune Tiger",
      image: "https://meta-game-share.s3.ap-east-1.amazonaws.com/pg/icon/fortune-tiger.png",
    },
    {
      game_id: 53,
      game_code: "the-great-icescape",
      name: "The Great Icescape",
      image: "https://meta-game-share.s3.ap-east-1.amazonaws.com/pg/icon/the-great-icescape.png",
    },
  ],
};

const ygg = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [
    {
      game_id: 55,
      game_code: "880102",
      name: "Raptor Doublemax",
      image: "https://meta-game-share.s3.ap-east-1.amazonaws.com/ygg/icon/880102.png",
    },
    {
      game_id: 86,
      game_code: "880143",
      name: "Vallet of the Gods",
      image: "https://meta-game-share.s3.ap-east-1.amazonaws.com/ygg/icon/880143.png",
    },
    {
      game_id: 95,
      game_code: "880153",
      name: "Lucky Neko",
      image: "https://meta-game-share.s3.ap-east-1.amazonaws.com/ygg/icon/880153.png",
    },
  ],
};

const evoplay = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const jili = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const jdb = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const pt = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const pplive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: false,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const fc = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const cq9 = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const playstar = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const welive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const weblockchain = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const welottery = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const tcg = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const jilifish = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  //USE IN V2
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  //END OF USE IN V2
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const youbet = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const aesexy = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const spribeone = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const wesport = {
  column: 1,
  isFrame: true,
  moreGameIsPopup: false,
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const luckysport = {
  column: 1,
  isFrame: true,
  moreGameIsPopup: false,
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const ybslot = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const wefish = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const weslot = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const fcfish = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const jdbfish = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const jdbslot = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const viacasinolive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const ffflive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const wcf = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const minigame = {
  column: 3,
  isFrame: true,
  gameRoutePrefix: JSON.parse(process.env.REACT_APP_SPECIAL_DIRECT)
    ? buildSubDomain("gameminigame")
    : process.env.REACT_APP_FLYGO_MOBILE_URL,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onejdbslot = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onejdbfish = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onepp = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onepg = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onehacksaw = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onejilislot = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onejilifish = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onejilicard = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onejilicasino = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const oneevolive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: process.env.REACT_APP_EVO_BANNER_GAMECODE ? false : true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onepplive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: process.env.REACT_APP_PP_BANNER_GAMECODE ? false : true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const oneaasexylive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: process.env.REACT_APP_AA_SEXY_BANNER_GAMECODE ? false : true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onedblive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: process.env.REACT_APP_DB_BANNER_GAMECODE ? false : true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onepalive = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: process.env.REACT_APP_PA_BANNER_GAMECODE ? false : true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const onecq9live = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: process.env.REACT_APP_CQ9_BANNER_GAMECODE ? false : true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};
const onesaba = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const oneglobal = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const agglobal = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const omgglobal = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: true,
  haveTutorial: false,
  showLotteryButton: true,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const sbosport = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: false,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const crsport = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: false,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const fbsport = {
  column: 3,
  isFrame: true,
  moreGameIsPopup: true,
  moreGameIsPopupV2: false,
  haveTutorial: false,
  showLotteryButton: false,
  gameItemOnClick: "openIFrameApiLink",
  game_list: [],
};

const gameListsEnum = {
  winlottery,
  mg,
  "77lottery": lottery77,
  saba,
  sabacricket,
  fbworldcup,
  jollysport,
  t1,
  evo,
  pp,
  pg,
  ygg,
  evoplay,
  jili,
  jdb,
  pt,
  pplive,
  fc,
  cq9,
  playstar,
  welive,
  weblockchain,
  welottery,
  tcg,
  jilifish,
  youbet,
  aesexy,
  spribeone,
  wesport,
  luckysport,
  ybslot,
  wefish,
  weslot,
  fcfish,
  jdbfish,
  jdbslot,
  viacasinolive,
  ffflive,
  wcf,
  minigame,
  onejdbslot,
  onejdbfish,
  onepp,
  onepg,
  onehacksaw,
  onejilislot,
  onejilifish,
  onejilicard,
  onejilicasino,
  oneevolive,
  onepplive,
  oneaasexylive,
  onedblive,
  onepalive,
  onecq9live,
  onesaba,
  onehabaneropoker: oneglobal,
  onekingmidaspoker: oneglobal,
  onekypoker: oneglobal,
  one365poker: oneglobal,
  onegtfslot: oneglobal,
  onemicroslot: oneglobal,
  onespadeslot: oneglobal,
  onerelaxslot: oneglobal,
  onehabaneroslot: oneglobal,
  onenetentslot: oneglobal,
  oneredtigerslot: oneglobal,
  onebigtimeslot: oneglobal,
  onenolimitcityslot: oneglobal,
  onebngslot: oneglobal,
  oneadvantplayslot: oneglobal,
  oneevoplayslot: oneglobal,
  onekingmidasslot: oneglobal,
  oneepicwinslot: oneglobal,
  onelive22slot: oneglobal,
  onecgslot: oneglobal,
  onedbslot: oneglobal,
  onethunderkickslot: oneglobal,
  onepaslot: oneglobal,
  oneplaytechslot: oneglobal,
  onealizeslot: oneglobal,
  oneavataruxslot: oneglobal,
  onethebetterslot: oneglobal,
  oneendorphinaslot: oneglobal,
  onelucky365slot: oneglobal,
  onewinfinitylive: oneglobal,
  oneyeebetlive: oneglobal,
  oneezugilive: oneglobal,
  onemicrolive: oneglobal,
  onewmlive: oneglobal,
  oneplaytechlive: oneglobal,
  onebiglive: oneglobal,
  onealizemini: oneglobal,
  oneaviatrixmini: oneglobal,
  onelitemini: oneglobal,
  oneaviatormini: oneglobal,
  onemicroarcade: oneglobal,
  agjilislot: agglobal,
  agpgslot: agglobal,
  agppslot: agglobal,
  agjdbslot: agglobal,
  agbgslot: agglobal,
  agfcslot: agglobal,
  agcpslot: agglobal,
  agwgslot: agglobal,
  agtadaslot: agglobal,
  aghsdslot: agglobal,
  omgspribe: omgglobal,
  omgpgslot: omgglobal,
  omgppslot: omgglobal,
  omghacksaw: omgglobal,
  omgjilislot: omgglobal,
  omgminigame: omgglobal,
  omgtadaslot: omgglobal,
  omgcpslot: omgglobal,
  omgaskmeslot: omgglobal,
  omglottery: omgglobal,
  omgcasino: omgglobal,
  omgjdbslot: omgglobal,
  omgwgslot: omgglobal,
  omg759slot: omgglobal,
  omgredtiger: omgglobal,
  omgfcslot: omgglobal,
  omgigtslot: omgglobal,
  omg2jgame: omgglobal,
  omgslotmill: omgglobal,
  omggameartslot: omgglobal,
  sbosport,
  crsport,
  fbsport,
};

export default gameListsEnum;
